<template>
  <a-row
    class="mb-layout"
    :class="{ 'is-slide-collapsed': slideCollapsed }"
    :gutter="[16, 16]"
  >
    <a-col
      :xs="0"
      :lg="slideCollapsed ? 2 : 6"
      class="mb-layout__col mb-layout__col--slide"
    >
      <div class="mb-card mb-card--slide">
        <SlideBuilding @collapsed-change="onSlideCollapsedChange" />
      </div>
    </a-col>

    <a-col
      :xs="24"
      :lg="slideCollapsed ? 22 : 18"
      class="mb-layout__col mb-layout__col--main"
    >
      <div class="mb-card mb-card--main">
        <DefaultBreadcrumb></DefaultBreadcrumb>
        <router-view />
      </div>
    </a-col>
  </a-row>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import SlideBuilding from '@/layouts/default/profile/SlideBuilding.vue'
import DefaultBreadcrumb from '@/components/ant/breadcrumb/DefaultBreadcrumb.vue'
const slideCollapsed = ref(true)

const onSlideCollapsedChange = (value: boolean) => {
  slideCollapsed.value = value
}
</script>

<style scoped>
.mb-layout {
  min-height: calc(100vh - 160px);
  padding: 4px 4px 16px;
}

.mb-layout__col {
  display: flex;
}

.mb-card {
  width: 100%;
  /* background: #fff; */
  /* border: 1px solid var(--brand-border, #e5e7eb); */
  border-radius: 16px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.mb-card--slide {
  padding: 12px 10px 16px;
  overflow: hidden;
}

.mb-card--main {
  padding: 16px 18px 24px;
  min-height: 100%;
}

.mb-layout.is-slide-collapsed .mb-card--slide {
  padding: 10px 6px;
}

@media (max-width: 991px) {
  .mb-layout {
    padding: 0 0 12px;
  }

  .mb-card--main {
    padding: 12px 12px 20px;
  }
}
</style>
